import { createAccordionComponent, IAccordionItemProperties, ACCORDION_BASE_CLASSNAME } from '@vfde-brix/accordion';
import { createImageSliderComponent, IImageSliderItem, IMAGE_SLIDER_BASE_CLASSNAME } from '@vfde-brix/image-slider';
import { accordionTracking, imageSliderTracking} from './tracking/accordions';

import {mountImageSlider} from 'Container/App/components/image-slider';
import {mountInteractionBar} from 'Container/App/components/interaction-bar';
import {mountMediaSegment} from 'Container/App/components/media-segment';
import {mountCardPicture} from 'Container/App/components/card-picture-cta';
import {mountImageHeader} from 'Container/App/components/image-header';

export const App = () => {
    const accordions = document.getElementsByClassName(ACCORDION_BASE_CLASSNAME);
    mountImageSlider();
    mountInteractionBar();
    mountCardPicture();
    mountImageHeader();

    const openedBefore = {};

    function toggleAccordion (isOpen, clickedAccordion, accordionId) {

        const imageSlidersInItem = clickedAccordion.accordionItem.getElementsByClassName(IMAGE_SLIDER_BASE_CLASSNAME);

        if (isOpen) {

            const sliderExist = !!imageSlidersInItem.length;

            if (sliderExist && !openedBefore[accordionId]) {
                imageSliderTracking(
                    clickedAccordion && clickedAccordion.stdHeadline,
                    1,
                );
            } else {
                accordionTracking(clickedAccordion.stdHeadline);
            }
        }
    }

    function registerCarousels (imageSliders, clickedAccordion) {

        for (let imageSliderCounter = 0; imageSliderCounter < imageSliders.length; imageSliderCounter++) {

            const imageslidenWrapper =  imageSliders[imageSliderCounter].parentElement;

            const imagesSlider = createImageSliderComponent(
                imageslidenWrapper,
                {
                    onSlide: (itemsLength: number, activeStep: number, selectedImage?: IImageSliderItem) => {

                        const currentIndex = ++activeStep;

                        imageSliderTracking(clickedAccordion && clickedAccordion.stdHeadline, activeStep === itemsLength ? 'last' : currentIndex  );
                    },
                },
            );
        }
    }

    if (accordions && accordions.length) {

        for (let accordionsCounter = 0; accordionsCounter < accordions.length; accordionsCounter++) {

            const accordionWrapper =  accordions[accordionsCounter].parentElement;

            const imageSliders = accordionWrapper.getElementsByClassName(IMAGE_SLIDER_BASE_CLASSNAME);

            const accordion = createAccordionComponent(
                accordionWrapper,
                {
                    onToggle: (accordionId: string, isOpen: boolean, clickedAccordion: IAccordionItemProperties) => {

                        toggleAccordion(isOpen, clickedAccordion, accordionId);

                        if (!openedBefore[accordionId]) {
                            registerCarousels(imageSliders, clickedAccordion);
                        }

                        if (isOpen) {
                            openedBefore[accordionId] = true;
                        }
                    },
                },
            );
        }
    }

    mountMediaSegment();
}

